export const TIDYCAL_URL = "https://tidycal.com/phillip2/60-minute-business-tech-consultation-clone20240330075633";
export const LINKTREE_URL = "https://linktr.ee/banksps";
export const EMAIL = "phillip@banksfamilytech.com";
export const PORTRAIT_URL = "/headshot.png";

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
